import { useState } from "react";
import AlertTablePerformance from "../../components/productsInfosComponents/PerformancePageComponents/AlertTablePerformance";
import CpuPerformanceCard from "../../components/productsInfosComponents/PerformancePageComponents/maxCpuGraph";
import MinAvailableRam from "../../components/productsInfosComponents/PerformancePageComponents/minAvailableRam";
import PerformanceSummary from "../../components/productsInfosComponents/PerformancePageComponents/performanceSummary";
import MaxCpuDetailsGraph from "../../components/productsInfosComponents/PerformanceDetailsComponents/maxCpuDetailsGraph";
import MinAvailableRamDaily from "../../components/productsInfosComponents/PerformanceDetailsComponents/minAvailableRam";
import MetricTotalCard from "../../components/productsInfosComponents/PerformancePageComponents/MetricTotalCard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DateRangeFilter from "../../components/productsInfosComponents/PerformancePageComponents/PeriodFilter";
import RamPerformanceCard from "../../components/productsInfosComponents/PerformancePageComponents/avgRamGraph";
import AvgUsedRamDaily from "../../components/productsInfosComponents/PerformanceDetailsComponents/avgUsedRam";
import DiskSpaceSummary from "../../components/productsInfosComponents/PerformancePageComponents/DiskSpaceSummary";
import NetworkInDetailsGraph from "../../components/productsInfosComponents/PerformanceDetailsComponents/NetworkInDetailsGraph";
import NetworkOutDetailsGraph from "../../components/productsInfosComponents/PerformanceDetailsComponents/NetworkOutDetailsGraph";
import DiskReadDetailsGraph from "../../components/productsInfosComponents/PerformanceDetailsComponents/DiskReadDetailsGraph";
import DiskWriteDetailsGraph from "../../components/productsInfosComponents/PerformanceDetailsComponents/DiskWriteDetailsGraph";
import AICpuRamAnalysisCard from "../../components/productsInfosComponents/PerformancePageComponents/AICpuRamAnalysisCard";

const PerformanceComponent = ({ vmIds, vmNames }) => {
  const [showDetails, setShowDetails] = useState(false);
  const [selectedDetailDate, setSelectedDetailDate] = useState(new Date());
  const [rangeStartDate, setRangeStartDate] = useState("");
  const [rangeEndDate, setRangeEndDate] = useState("");
  const vmIdList = vmIds && Array.isArray(vmIds) ? vmIds : vmIds ? [vmIds] : [];

  const formatDateForApi = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const toggleView = () => {
    setShowDetails(!showDetails);
  };

  const handleRangeChange = (startDate, endDate) => {
    setRangeStartDate(startDate);
    setRangeEndDate(endDate);
  };

  return (
    <div className="p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
        {showDetails ? (
          <div className="bg-primary-cyan rounded-lg p-1 w-full sm:w-auto">
            <DatePicker
              selected={selectedDetailDate}
              onChange={(date) => setSelectedDetailDate(date)}
              dateFormat="dd/MM/yyyy"
              maxDate={new Date()}
              className="bg-primary-cyan text-white px-3 py-2 rounded-lg focus:outline-none cursor-pointer w-full sm:w-auto text-sm"
            />
          </div>
        ) : (
          <div className="w-full sm:w-auto">
            <DateRangeFilter onRangeChange={handleRangeChange} />
          </div>
        )}
        <div className="w-full sm:w-auto flex justify-end">
          <button
            onClick={toggleView}
            className="bg-primary-cyan hover:bg-primary-cyan/80 text-white px-4 py-2 rounded-lg font-medium transition text-sm sm:text-base w-full sm:w-auto"
          >
            {showDetails ? "See Global" : "See Details"}
          </button>
        </div>
      </div>

      {!showDetails ? (
        <div className="space-y-4 sm:space-y-6">
          <div className="grid grid-cols-1 gap-4 sm:gap-6">
            <CpuPerformanceCard vmIds={vmIdList} startDate={rangeStartDate} endDate={rangeEndDate} />
            <RamPerformanceCard vmIds={vmIdList} startDate={rangeStartDate} endDate={rangeEndDate} />
            <MinAvailableRam vmIds={vmIdList} startDate={rangeStartDate} endDate={rangeEndDate} />
          </div>
          <AICpuRamAnalysisCard vmIds={vmIdList} />
          <PerformanceSummary vmIds={vmIdList} startDate={rangeStartDate} endDate={rangeEndDate} />
          <div className="space-y-4 sm:space-y-6">
            <MetricTotalCard vmIds={vmIdList} metricType="DISK_READ" startDate={rangeStartDate} endDate={rangeEndDate} />
            <MetricTotalCard vmIds={vmIdList} metricType="DISK_WRITE" startDate={rangeStartDate} endDate={rangeEndDate} />
            <MetricTotalCard vmIds={vmIdList} metricType="NETWORK_IN" startDate={rangeStartDate} endDate={rangeEndDate} />
            <MetricTotalCard vmIds={vmIdList} metricType="NETWORK_OUT" startDate={rangeStartDate} endDate={rangeEndDate} />
          </div>
          <DiskSpaceSummary vmIds={vmIdList} />
          <div className="overflow-x-auto">
            <AlertTablePerformance vmIds={vmIdList} vmNames={vmNames} />
          </div>
        </div>
      ) : (
        <div className="space-y-4 sm:space-y-6">
          <div className="grid grid-cols-1 gap-4 sm:gap-6">
            <MaxCpuDetailsGraph vmIds={vmIdList} date={formatDateForApi(selectedDetailDate)} />
            <AvgUsedRamDaily vmIds={vmIdList} date={formatDateForApi(selectedDetailDate)} />
            <MinAvailableRamDaily vmIds={vmIdList} date={formatDateForApi(selectedDetailDate)} />
            <NetworkInDetailsGraph vmIds={vmIdList} date={formatDateForApi(selectedDetailDate)} />
            <NetworkOutDetailsGraph vmIds={vmIdList} date={formatDateForApi(selectedDetailDate)} />
            <DiskReadDetailsGraph vmIds={vmIdList} date={formatDateForApi(selectedDetailDate)} />
            <DiskWriteDetailsGraph vmIds={vmIdList} date={formatDateForApi(selectedDetailDate)} />
          </div>
        </div>
      )}
    </div>
  );
};

export default PerformanceComponent;